// 🎃 10-07 pumpkins (P7): the page's three calls to the carving table (backend src/ChatGame/housePumpkins.js).
// · carve + hide ride the interjection route as body.pumpkin / body.pumpkin_hide (the CFN-cap piggyback) and the
//   backend ALWAYS answers no_wake: a carve costs no AI and never wakes the room, so these are direct POSTs and
//   the page never starts a step after one (verify-pumpkin-carving.js watches for one).
// · the porch read is a POST on /api/takeGameStep (the handler's `housePumpkins` branch lives in
//   'get:takeGameStep', the getRoomArtifacts shape; a bare /api reaches no handler: the 10-07 review's blocker).
//   Keyless works (the per-IP bucket). A proven seat's id + secret ride the BODY (a GET's URL is logged) and
//   bring back `mine`, and a maintainer seat `can_hide`.
// Its own module (not chatGameApi.js, a hot shared file): the calls are the whole surface.
import { API_BASE_URL } from '../config/api';

export const FAILED = "That didn't go through. Try again.";

async function postInterjection(body) {
  const response = await fetch(`${API_BASE_URL}/chat-game/interjection`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || !json.success) throw new Error(json.error || FAILED);
  return json;
}
const seat = (playerId, playerSecret) => ({ player_id: playerId, ...(playerSecret ? { player_secret: playerSecret } : {}) });

/** Put your pumpkin on the porch, or re-carve it. → the backend's answer:
 *  { ok: true, id, name, again, hidden } or { ok: false, reason, message } (its own words). Throws on a 4xx. */
export async function submitPumpkin({ gameId, playerId, playerSecret, name, cuts }) {
  const json = await postInterjection({ game_id: gameId, ...seat(playerId, playerSecret), pumpkin: { name, cuts } });
  return json.pumpkin || { ok: false, message: FAILED };
}

/** Hide (or un-hide) one pumpkin: a maintainer seat in this room only. → { ok, … } or { ok: false, message }. */
export async function hidePumpkin({ gameId, playerId, playerSecret, pumpkinId, hidden = true }) {
  const json = await postInterjection({ game_id: gameId, ...seat(playerId, playerSecret), pumpkin_hide: { pumpkin_id: pumpkinId, hidden: hidden !== false } });
  return json.pumpkin || { ok: false, message: FAILED };
}

/** The porch: { success, open, opens_at, until, glow, count, spots, rest, mine, can_hide, page?, hidden? }. */
export async function fetchPorch({ gameId, playerId = null, playerSecret = null, page = null }) {
  const body = {
    housePumpkins: true,
    gameInstanceId: gameId,
    ...(playerId ? seat(playerId, playerSecret) : {}),
    ...(Number.isInteger(page) && page >= 1 ? { page } : {}),
  };
  const response = await fetch(`${API_BASE_URL}/api/takeGameStep`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || !json || json.success !== true) throw new Error((json && json.error) || FAILED);
  return json;
}
